
import { Vue, Component } from 'vue-property-decorator'
import memberApi from '@/apis/member/member';
import moment from 'moment';
import {MyVipCardValid} from '@/interfaces/vuexStateInterface';
import StudentHomeApi from '@/apis/ktpStudentHome';

// VIP 列表
@Component
export default class VipList extends Vue {
  private VIPList: any[] = [];
  readonly moment: any = moment;
  private isVip: number = 0;
  private minPriceVipCard:any = {};
  private minPrice = 2.9;//单位是元

  get vipValid(): MyVipCardValid {
    return this.$store.getters.getMyVipCardValid;
  }
  get userInfo(): any {
    return this.$store.getters.getUserInfo;
  }

  //获取价格最低学习卡的价格
  getMinPriceVipCardInfo(){
    StudentHomeApi.getMinPriceVipCard().then((res:any)=>{
      this.minPriceVipCard = res;
      if(this.minPriceVipCard){
        this.minPrice = this.minPriceVipCard['price']/100;
      }
    });
  }

  created() {
    this.$store.dispatch('setMyVipCardValid');
    this.getMinPriceVipCardInfo();
    memberApi.getUserVipSetting({}).then((res: any) => {
      this.isVip = res.isVip;
      if(({}).toString.call(res.vipdate) === "[object Array]") {
        this.VIPList = res.vipdate;
      } else {
        this.VIPList = [res.vipdate];
      }
    })
  }
}
